import { get, post, put, remove } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export type WorkflowKind = "prompt" | "review" | "compare" | "summarize";

export interface Workflow {
  id: string;
  name: string;
  description: string | null;
  /** What to ask QAgent; {{document}} is replaced by the chosen document */
  instructions: string;
  kind: WorkflowKind;
  playbookId: string | null;
  standardAgreementId: string | null;
  visibility: "private" | "organization";
  /** Owner's name, when someone else made it */
  ownerName: string | null;
  canEdit: boolean;
  updatedAt: string;
}

export type WorkflowInput = Pick<
  Workflow,
  "name" | "description" | "instructions" | "kind" | "playbookId" | "standardAgreementId" | "visibility"
>;

export const listWorkflows = (): Promise<ApiResponse<Workflow[]>> => get(`/workflows`, null);

export const createWorkflow = (data: WorkflowInput): Promise<ApiResponse<Workflow>> =>
  post(`/workflows`, data, null);

export const updateWorkflow = (id: string, data: WorkflowInput): Promise<ApiResponse<Workflow>> =>
  put(`/workflows/${id}`, data);

export const deleteWorkflow = (id: string): Promise<ApiResponse<void>> =>
  remove(`/workflows/${id}`, null);

/** The instructions with the chosen document's name in place of {{document}} */
export const fillWorkflow = (instructions: string, documentName?: string) =>
  instructions.replace(/\{\{\s*document\s*\}\}/gi, documentName ? `@[${documentName}]` : "the document");
